const convertColorName = (
  cmsColorValue: ColorName | undefined,
): string | undefined => {
  if (cmsColorValue) {
    if (cmsColorValue.toString() === 'DARK_BLUE') {
      return 'blue.700';
    } else if (cmsColorValue.toString() === 'LIGHT_BLUE') {
      return 'blue.50';
    } else if (cmsColorValue.toString() === 'DARK_RED') {
      return 'red.800';
    } else if (cmsColorValue.toString() === 'WHITE') {
      return 'white';
    }
  }

  return undefined;
};

const isDarkColor = (color: ColorName) => {
  if (color) {
    if (color.toString() === 'DARK_BLUE' || color.toString() === 'DARK_RED') {
      return true;
    }
  }
  return false;
};

export { convertColorName, isDarkColor };
